module.exports = __webpack_public_path__ + "static/media/minimalUrbanBike.3b27d6b1.png";